require('../../modules/es6.array.map');
module.exports = require('../../modules/_core').Array.map;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/map.js
// module id = 836
// module chunks = 0